/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_DescInputs */

const en_settings_profile_desc = /** @type {(inputs: Settings_Profile_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account details.`)
};

const id_settings_profile_desc = /** @type {(inputs: Settings_Profile_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi akun kamu.`)
};

/**
* | output |
* | --- |
* | "Your account details." |
*
* @param {Settings_Profile_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_profile_desc = /** @type {((inputs?: Settings_Profile_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_profile_desc(inputs)
	return en_settings_profile_desc(inputs)
});